const features = [
  {
    icon: "ri-hd-line",
    title: "高清画质",
    desc: "支持高清及以上清晰度，画面细腻流畅",
  },
  {
    icon: "ri-stack-line",
    title: "海量资源",
    desc: "覆盖电视剧、电影、综艺多类型内容",
  },
  {
    icon: "ri-refresh-line",
    title: "每日更新",
    desc: "热门剧集与综艺持续跟进更新",
  },
  {
    icon: "ri-device-line",
    title: "多端适配",
    desc: "电脑与手机均可舒适浏览与观看",
  },
];

export default function SiteIntro() {
  return (
    <section className="w-full max-w-[1400px] mx-auto px-4 md:px-6 pt-10 md:pt-14">
      <div className="rounded-lg bg-accent-50 border border-accent-100 p-6 md:p-10">
        <div className="max-w-3xl">
          <h2 className="font-heading text-xl md:text-2xl font-black text-foreground-950">
            关于爱看视频
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            爱看视频是一家提供影视剧、电影与综艺节目在线观看的综合影视平台。我们汇聚最新剧集、
            热门电影与口碑综艺，通过清晰的分类、便捷的筛选与搜索，帮助每一位影视爱好者快速发现
            想看的内容，享受沉浸式的观影浏览体验。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="rounded-lg bg-background-50 border border-accent-100 p-5"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className={`${feature.icon} text-xl`}></i>
              </span>
              <h3 className="mt-3 text-sm font-bold text-foreground-900">
                {feature.title}
              </h3>
              <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}